import React from 'react';
import 'react-quill/dist/quill.snow.css';
import './EditorToolbar.css';

import textColorIcon from '../assets/MessageIcons/textcolor.svg';
import attachmentIcon from '../assets/MessageIcons/attachment.svg';
import linkIcon from '../assets/MessageIcons/link.svg';
import emojiIcon from '../assets/MessageIcons/emoji.svg';
import gdocIcon from '../assets/MessageIcons/gdoc.svg';
import imgIcon from '../assets/MessageIcons/img.svg';
import lockIcon from '../assets/MessageIcons/lock.svg';
import penIcon from '../assets/MessageIcons/pen.svg';
import moreIcon from '../assets/MessageIcons/more.svg';

const BottomTools = () => {
  return (
    <div id="bottom-toolbar" className="ql-toolbar ql-snow">
      <span className="ql-formats">
        <button className="ql-textcolor">
          <img src={textColorIcon} alt="Text Color" width="22" />
        </button>
        <button className="ql-attachment">
          <img src={attachmentIcon} alt="Attach File" width="22" />
        </button>
        <button className="ql-link">
          <img src={linkIcon} alt="Insert Link" width="22" />
        </button>
        <button className="ql-emoji">
          <img src={emojiIcon} alt="Insert Emoji" width="22" />
        </button>
        <button className="ql-gdoc">
          <img src={gdocIcon} alt="Google Doc" width="22" />
        </button>
        <button className="ql-image">
          <img src={imgIcon} alt="Insert Image" width="22" />
        </button>
        <button className="ql-loc">
          <img src={lockIcon} alt="Location" width="22" />
        </button>
        <button className="ql-pen">
          <img src={penIcon} alt="Pen Tool" width="22" />
        </button>
        <button className="ql-mor">
          <img src={moreIcon} alt="More" width="22" />
        </button>
      </span>
    </div>
  );
};

export default BottomTools;
